<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import { createRealEstateBrokerInvestmentPresenter } from '../composables/realEstateBrokerInvestmentPresenter';

defineProps({
  investment: { type: Object, required: true },
});

const { t } = useI18n();
const { date, money } = createRealEstateBrokerInvestmentPresenter(t);
</script>

<template>
  <LaisCard density="tight">
    <div class="grid gap-4 p-5 sm:grid-cols-3 sm:p-6">
      <div class="rounded-lais bg-lais-bg-soft p-4">
        <p
          class="text-xs font-semibold uppercase tracking-wide text-lais-text-muted"
        >
          {{ t('REAL_ESTATE_BROKER_INVESTMENT.DETAIL.ANNOUNCED_VALUE') }}
        </p>
        <p class="mt-2 text-xl font-bold text-lais-text">
          {{ money(investment.valor_anunciado) }}
        </p>
      </div>
      <div class="rounded-lais bg-lais-bg-soft p-4">
        <p
          class="text-xs font-semibold uppercase tracking-wide text-lais-text-muted"
        >
          {{ t('REAL_ESTATE_BROKER_INVESTMENT.DETAIL.LAST_UPDATED') }}
        </p>
        <p class="mt-2 font-semibold text-lais-text">
          {{ date(investment.atualizado_em) }}
        </p>
      </div>
      <div class="rounded-lais bg-lais-bg-soft p-4">
        <p
          class="text-xs font-semibold uppercase tracking-wide text-lais-text-muted"
        >
          {{ t('REAL_ESTATE_BROKER_INVESTMENT.DETAIL.CAPTURED_AT') }}
        </p>
        <p class="mt-2 font-semibold text-lais-text">
          {{ date(investment.criado_em) }}
        </p>
      </div>
    </div>
  </LaisCard>
</template>
